export type HowWeWorkTileDef = {
    iconIndex: number;
    titleKey: string;
    descriptionKey: string;
};

export const HOW_WE_WORK_TILES: readonly HowWeWorkTileDef[] = [
    {
        iconIndex: 0,
        titleKey: 'how-we-work.tiles.1.title',
        descriptionKey: 'how-we-work.tiles.1.description',
    },
    {
        iconIndex: 1,
        titleKey: 'how-we-work.tiles.2.title',
        descriptionKey: 'how-we-work.tiles.2.description',
    },
    {
        iconIndex: 2,
        titleKey: 'how-we-work.tiles.3.title',
        descriptionKey: 'how-we-work.tiles.3.description',
    },
] as const;
